export enum AuthenticationType {
  Password = 0,
  Sso = 1,
  Api = 2,
  Passwordless = 3,
}
